/* esm.sh - lodash-es@4.18.1/debounce */
export * from "/*lodash-es@4.18.1/esnext/debounce.mjs";
export { default } from "/*lodash-es@4.18.1/esnext/debounce.mjs";
